import { userRepo } from "@/repositories/userRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";

export const useGetUser = (userId: string) => {
  return useObservable(() => userRepo.get(userId), [userId]);
};

export const useUserList = (tenantId: string) => {
  return useObservable(() => userRepo.list(tenantId), [tenantId]);
};
